import { render, staticRenderFns } from "./LogsView.vue?vue&type=template&id=730e8792&scoped=true&"
import script from "./LogsView.vue?vue&type=script&lang=ts&"
export * from "./LogsView.vue?vue&type=script&lang=ts&"
import style0 from "./LogsView.vue?vue&type=style&index=0&id=730e8792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730e8792",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
